$(document).ready(function(){

    var $slides = $('.vv_ready-grid-cell');
    var currentIndex = 0;

    function showSlide(index) {
        $slides.addClass('hidedMob');
        $slides.eq(index).removeClass('hidedMob');
    }

    $('.next__ar').on('click', function() {
        currentIndex++;

        if (currentIndex >= $slides.length) {
            currentIndex = 0;
        }

        showSlide(currentIndex);
    });

    $('.prev__ar').on('click', function() {
        currentIndex--;

        if (currentIndex < 0) {
            currentIndex = $slides.length - 1;
        }

        showSlide(currentIndex);
    });

    // Initialize
    showSlide(currentIndex);


    $('.vv_section__outer.doing-outer').each(function () {
        var $section = $(this);
        var $outer = $section.find('.vv_doing-outer');
        var $boxes = $section.find('.vv_doing-box');
        var $nav = $section.find('.vv_doing-nav');
        var currentIndex = 0;
        var leftGap = 16;

        if ($boxes.length < 5) {
        $nav.addClass('hidedDesktop');
        }

        function slideToBox(index) {
        if (index < 0) index = 0;
        if (index > $boxes.length - 1) index = $boxes.length - 1;

        currentIndex = index;

        var outerLeft = $outer.offset().left;
        var boxLeft = $boxes.eq(currentIndex).offset().left;
        var currentScroll = $outer.scrollLeft();

        var newScroll = currentScroll + (boxLeft - outerLeft) - leftGap;

        $outer.stop().animate({
            scrollLeft: newScroll
        }, 300);
        }

        $section.find('.arr_next').on('click', function () {
        slideToBox(currentIndex + 1);
        });

        $section.find('.arr_prev').on('click', function () {
        slideToBox(currentIndex - 1);
        });
    });



   let lastScroll = 0;
    const $header = $('.vv_header__outer');
    const $stickyBox = $('.vv_sticky-box_outer');
    const $atcBtn = $('.he_product-atc_long');

    function updateStickyBox() {
        const scrollTop = $(window).scrollTop();
        const pageHeight = $(document).height() - $(window).height();
        const scrollPercent = (scrollTop / pageHeight) * 100;

        const atcBtn = $atcBtn[0];
        let atcInView = false;

        if (atcBtn) {
            const rect = atcBtn.getBoundingClientRect();
            atcInView = rect.top < window.innerHeight && rect.bottom > 0;
        }

        if (scrollPercent >= 10 && scrollPercent < 98 && !atcInView) {
            $stickyBox.removeClass('notvisible');
        } else {
            $stickyBox.addClass('notvisible');
        }
    }

    $(window).on('scroll', function () {
        const scrollTop = $(this).scrollTop();

        if (scrollTop <= 50) {
            $header.removeClass('scrollingDown scrollingUp');
        } else if (scrollTop > lastScroll) {
            $header.addClass('scrollingDown').removeClass('scrollingUp');
        } else if (scrollTop < lastScroll) {
            $header.addClass('scrollingUp').removeClass('scrollingDown');
        }

        lastScroll = scrollTop;

        updateStickyBox();
    });

    // Run once on load in case page is already scrolled
    updateStickyBox();

});